
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/outrun-cloud",
      function () {
        return require("private-next-pages/outrun-cloud.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/outrun-cloud"])
      });
    }
  